(function(){
'use strict';

angular
    .module('app')
    .controller('ConfirmEmailController', ConfirmEmailController);

    ConfirmEmailController.$inject = ['$rootScope', '$scope', '$location', 'UserService', '$routeParams'];
    function ConfirmEmailController($rootScope, $scope, $location, UserService, $routeParams) {

        initController();

        function initController() {
            $rootScope.PAGE.style = "no-menu confirmation";
            $scope.token = $routeParams.token;
            console.info('TOKEN', $scope.token);
            UserService.ConfirmEmail($scope.token, function (success, data) {
                $scope.confirmSuccess = success;
                if (success) {
                    $scope.email = data.value;
                }
                $scope.processed = true;
            });
        }
    }
})();